import { useModal } from "@ebay/nice-modal-react";
import { t } from "@/i18n-js/instance";
import { ModalManager } from "@/react/components/Layout/ModalManagerProvider";
import { ShareNotice } from "@/react/components/shared/ModalsV2/MomentumModal/ShareNotice";
import { Icon } from "@circle-react-shared/Icon";
import { MomentumModal } from "@circle-react-shared/ModalsV2/MomentumModal";
import { ActionButton } from "@circle-react-shared/ModalsV2/MomentumModal/ActionButton";
import { useConvertEventToBroadcast } from "./hooks/useConvertEventToBroadcast";

const LOCALE_NAMESPACE = "events.connection_modal";

interface EventMomentumModalProps {
  eventId: number;
  spaceName: string;
}

export const EventMomentumModal = ModalManager.create(function EventMoMo({
  eventId,
  spaceName,
}: EventMomentumModalProps) {
  const modal = useModal();
  const { onSendAnnouncement, isLoading } = useConvertEventToBroadcast();

  const handleSendAnnouncement = () => {
    onSendAnnouncement({ eventId, onSuccess: () => void modal.hide() });
  };

  return (
    <MomentumModal
      isOpen={modal.visible}
      onClose={modal.hide}
      title={t([LOCALE_NAMESPACE, "title"])}
      description={t([LOCALE_NAMESPACE, "description"], {
        space_name: spaceName,
      })}
      isLoading={isLoading}
      data-testid="event-momentum-modal"
    >
      <div className="flex flex-col gap-y-10">
        <ShareNotice>
          <ActionButton
            iconEl={<Icon type="20-page-edit-text" size={20} />}
            onClick={handleSendAnnouncement}
            disabled={isLoading}
            data-testid="send-announcement-event-button"
          >
            {t([LOCALE_NAMESPACE, "review_draft"])}
          </ActionButton>
        </ShareNotice>
      </div>
    </MomentumModal>
  );
});
